import styled, { css, keyframes } from 'styled-components';
import device from '../../../mediaQueries';

const fadeIn = props => css`
  ${keyframes`
    0% {opacity: 0;}
    100% {opacity: 1;}
  `}
`;
const CloseNavigationMenu = styled.img`
  width: 20px;
  height: auto;
  position: fixed;
  left: 565px;
  ${device.phone`
    left: calc((100vw * 0.75) + 15px);
  `}
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  top: 0.75em;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  z-index: 12;
  ${({ visible }) => (visible ? `animation: ${fadeIn} 0.5s ease-in;` : null)} animation-direction: alternate;
`;

export default CloseNavigationMenu;
